import moment from 'moment';
import { SUBMIT_CALENDAR_CUTOFF_SUCCESS, SUBMIT_CALENDAR_SUCCESS, CLEAR_CALENDAR } from './actions';

const calendar = (state = {}, action) => {
	switch (action.type) {
		case SUBMIT_CALENDAR_SUCCESS: {
			const dates = action.payload.dates.map((date) => ({
				settlement: moment(date.settlement),
				submission: moment(date.submission),
			}));
			return {
				...state,
				dates,
			};
		}
		case SUBMIT_CALENDAR_CUTOFF_SUCCESS: {
			return {
				...state,
				cut_offs: action.payload.cut_offs,
			};
		}
		case CLEAR_CALENDAR: {
			return {
				...state,
				dates: [],
			};
		}
		default:
			return state;
	}
};

export default calendar;
